import { render, staticRenderFns } from "./CampaignRecipient.vue?vue&type=template&id=9f3ce682&scoped=true&"
import script from "./CampaignRecipient.vue?vue&type=script&lang=js&"
export * from "./CampaignRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3ce682",
  null
  
)

export default component.exports